import { Box, styled } from '@mui/material'
import React from 'react'

import RadioButton from '../../../components/global/interactions/RadioButton'
import { COLORS } from '../../../constants/colors'
import { fontSize } from '../../../themes/themes'
import BannerLabel, { BannerType } from './BannerLabel'

export enum BannerRadioButtonStyle {
  Primary,
  Secondary
}

interface BannerRadioButtonProps {
  currentBannerType: BannerType
  onChange: (bannerType: BannerType) => void
  bannerType: BannerType
  isDisabled?: boolean
  style?: BannerRadioButtonStyle
  customWidth?: string
  customHeight?: string
}

interface BannerRadioButtonBoxProps {
  customWidth: string
  customHeight: string
}

const BannerRadioButton = ({
  bannerType,
  onChange,
  currentBannerType,
  isDisabled,
  customWidth = '100px',
  customHeight = '64px',
  style = BannerRadioButtonStyle.Primary
}: BannerRadioButtonProps) => {
  const isPrimaryStyle = style === BannerRadioButtonStyle.Primary
  const BannerRadioButtonBox = isPrimaryStyle ? PrimaryBannerRadioButtonBox : SecondaryBannerRadioButtonBox
  return (
    <BannerRadioButtonBox customWidth={customWidth} customHeight={customHeight}>
      <Box height={isPrimaryStyle ? '84px' : '0px'} />
      <BannerLabel bannerType={bannerType} style={style} />
      <Box padding={isPrimaryStyle ? 0 : 2}>
        <RadioButton
          noBorder
          label='ใช้งาน'
          value={bannerType.toString()}
          onClick={() => (isDisabled ? undefined : onChange(bannerType))}
          currentValue={currentBannerType.toString()}
          textSize={fontSize.body1}
          isDisabled={isDisabled}
        />
      </Box>
    </BannerRadioButtonBox>
  )
}

const PrimaryBannerRadioButtonBox = styled(Box, {
  shouldForwardProp: (props) => !['customWidth', 'customHeight'].includes(props as string)
})<BannerRadioButtonBoxProps>(({ theme, customWidth, customHeight }) => ({
  border: `1px solid ${COLORS.grey100}`,
  padding: theme.spacing(2),
  borderRadius: theme.spacing(2),
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  position: 'relative',
  height: customHeight,
  width: customWidth,
  overflow: 'hidden'
}))

const SecondaryBannerRadioButtonBox = styled(Box, {
  shouldForwardProp: (props) => !['customWidth', 'customHeight'].includes(props as string)
})<BannerRadioButtonBoxProps>(({ theme, customWidth, customHeight }) => ({
  border: `1px solid ${COLORS.grey100}`,
  borderRadius: theme.spacing(2),
  height: customHeight,
  width: customWidth
}))

export default BannerRadioButton
